module.exports = __webpack_public_path__ + "img/pagamento-03.8f1e7033.png";